export function ChatFooter({ children }: React.PropsWithChildren) {
	return (
		<div className="plt-desktop:sm:px-[max(calc(calc(100vw-640px)/2),--spacing(4))] p-4">
			{children}
		</div>
	);
}
